import { Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: "app-welcome-dialog",
  standalone: true,
  imports: [],
  templateUrl: "./welcome-dialog.component.html",
  styleUrl: "./welcome-dialog.component.css",
})
export class WelcomeDialogComponent {
  greetingMessage: string = "";
  email: string = "";
  loginAccessData: string = "";
  loginSaData: string = "";
  constructor(
    private dialog: MatDialog,
    private cookieService: CookieService
  ) {}

  ngOnInit() {
    const name:any = sessionStorage.getItem("userName");
    this.email = name;
    const loginAccess:any = sessionStorage.getItem("login_access");
    this.loginAccessData = loginAccess;
    const loginSa:any = sessionStorage.getItem("login_sa");
    this.loginSaData = loginSa;

    if (this.loginAccessData == "Yes" && this.loginSaData == "Yes") {
      this.greetingMessage =
        "Welcome to LGT Wealth  Admin Portal, " + this.email + "!";
    } else {
      this.greetingMessage =
        "Welcome to LGT Wealth  User Portal, " + this.email + "!";
    }
  }

  onCancelClick() {
    sessionStorage.setItem("isSeenWelcome", "true");
    this.dialog.closeAll();
  }
}
